import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { VND_UNIT } from '../../../constants'

const DynamicUnit = ({ formatCurrency, val }) => {
  const { unitName, currency } = formatCurrency

  let unit = val.unit
  if (unit === VND_UNIT) unit = `${unitName} ${currency}`

  return (
    <Element style={{ fontSize: 14 }} className={'fw600'}>
      <span>
        {val.ratioName}
        <Translate value="portfolio.finance.OVER_5_YEARS" />
      </span>
      <Element elementName="span" style={{ color: '#9C9C9C' }}>
        {`(${unit})`}
      </Element>
    </Element>
  )
}

export default DynamicUnit
